/*
 * Lib Module Lightbox
 */

Lib.Lightbox = (function() {

    var self = {};

    $(Lib).on('document.ready', function() {
        self.initialize($('[data-lightbox]'));
        $(document).on('click', '.gallery-item', function(e) {
            e.preventDefault();
        });

        $(document).on('click', '[data-lightbox-open]', function(e) {
            e.preventDefault();
            let lightboxId = $(this).data('lightbox-open');
            $(`[data-lightbox="${lightboxId}"`).find('.gallery-item:first').click();
        });
    });

    self.initialize = function(elLightbox) {
        elLightbox.each(function() {
            var options = $.extend(true, {
                selector: '.gallery-item',
                speed: 200,
                pause: 3e3
            }, $(this).data('lightbox'));

            $(this).lightGallery(options);
        });
    };

    self.update = function(el) {
        if (typeof el === 'undefined') {
            $('[data-lightbox]').each(function() {
                var gal = $(this).data('lightGallery');
                if (gal) {
                    gal.destroy(true);
                }
                var dis = $(this);
                setTimeout(function() {
                    self.initialize(dis);
                }, 100);
            });
        } else {
            var gal = el.data('lightGallery');
            if (gal) {
                gal.destroy(true);
            }
            setTimeout(function() {
                self.initialize(el);
            }, 100);
        }
    };

    self.destroy = function(el) {
        if (typeof el === 'undefined') {
            $('[data-lightbox]').each(function() {
                var gal = $(this).data('lightGallery');
                if (gal) {
                    gal.destroy(true);
                }
            });
        } else {
            var gal = el.data('lightGallery');
            if (gal) {
                gal.destroy(true);
            }
        }
    };

    return self;
})();
